import { Reason } from './reason';

export enum AssociationStatusConfigurationTypes {
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
  DECLINED = 'DECLINED',
}

export interface AssociationStatusConfiguration {
  id: string;
  externalId: string;
  label: string;
  children: AssociationStatusConfiguration[];
  isShortListState: boolean;
  isRejectedState: boolean;
  isProspectState: boolean;
  isHiredState: boolean;
  blockForward: boolean;
  reasons: Reason[];
  position: number;
  type: AssociationStatusConfigurationTypes;
  icon?: string;
}
